document.addEventListener('click', function (event) {
  var button = event.target.closest('.lb-video__play');
  if (!button) return;
  var frame = button.closest('[data-lb-video]');
  if (!frame) return;
  var id = frame.getAttribute('data-lb-video');
  if (!/^[A-Za-z0-9_-]{6,20}$/.test(id)) return;
  var iframe = document.createElement('iframe');
  iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
  iframe.title = frame.getAttribute('data-lb-video-title') || 'YouTube video';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
  iframe.allowFullscreen = true;
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  frame.replaceChildren(iframe);
  iframe.focus();
});
